export class DeveloperFormatter {
  interpolate(message, values) {
    return `{{${message}}}`;
  }
}

export default new DeveloperFormatter();
